import './minidash.scss'
import React, { useState, useEffect, useRef } from 'react'

function Minidash(props) {

  const [isMore, setIsMore] = useState(null)

  const [diffPercentage, setDiffPercentage] = useState("-")
  const boxInd1 = useRef()
  const boxInd2 = useRef()
  let rowRef = useRef();
  let moreBoxRef = useRef();
  let lessBoxRef = useRef();
  let percentageBoxRef = useRef();
  let expenseTextRef = useRef();
  let thanTextRef = useRef();

  useEffect(() => {
    function handleResize() {

    }
    window.addEventListener('resize', handleResize)
    return _ => window.removeEventListener('resize', handleResize)
  })

  useEffect(() => {
    if (props.volume1 && props.volume2) {
      const vol1 = parseInt(props.volume1.replace(",", ""));
      const vol2 = parseInt(props.volume2.replace(",", ""));
      const highNum = Math.max(vol1, vol2)
      const lowNum = Math.min(vol1, vol2)
      const diff = highNum - lowNum
      setDiffPercentage(Math.round(diff / highNum * 100));
      if (vol1 > vol2) {
        setIsMore(true)
      } else if (vol1 < vol2) {
        setIsMore(false)
      } else {
        setIsMore(undefined)
      }
    }
  }, [props.volume1, props.volume2])

  useEffect(() => {
    if (props.isMobile) {
      rowRef.current.classList.add('mobile');
      moreBoxRef.current.classList.add('hidden');
      expenseTextRef.current.classList.add('mobile');
      thanTextRef.current.classList.add('mobile');

      lessBoxRef.current.classList.add('hidden');
      if (isMore === true) {
        moreBoxRef.current.classList.remove('hidden');
      }
      if (isMore === false) {
        lessBoxRef.current.classList.remove('hidden');
      }
    } else {
      expenseTextRef.current.classList.remove('mobile');
      thanTextRef.current.classList.remove('mobile');
      rowRef.current.classList.remove('mobile');
      lessBoxRef.current.classList.remove('hidden');
      moreBoxRef.current.classList.remove('hidden');
      rowRef.current.style.gridTemplateAreas = "firstIndustry expenseTextRef percentageFigure moreOrLessBoxRef thanTextRef secondIndustry";

    }
  })

  useEffect(() => {
    // Reduce font size for the first Industry Box
    const minSize = 140;
    let curSize = 180;
    while ((boxInd1.current.clientWidth) < (boxInd1.current.scrollWidth + 10) && curSize >= minSize) {
      boxInd1.current.style.fontSize = `${curSize -= 15}%`;
    }
    boxInd2.current.style.fontSize = curSize;
  })

  useEffect(() => {
    // Reduce font size for the first Industry Box
    const minSize = 180;
    let curSize = 300;
    while ((boxInd2.current.clientWidth) < (boxInd2.current.scrollWidth + 10) && curSize >= minSize) {
      boxInd2.current.style.fontSize = `${curSize -= 15}%`;
    }
    boxInd1.current.style.fontSize = curSize;
  })
  useEffect(() => {
    // Reduce font size for the second Industry Box
    const minSize = 180;
    let curSize = 300;
    while ((boxInd1.current.clientWidth) < (boxInd1.current.scrollWidth + 10) && curSize >= minSize) {
      boxInd1.current.style.fontSize = `${curSize -= 15}%`;
    }
    boxInd2.current.style.fontSize = curSize;
  })
  // useEffect(() => {
  //   // Reduce font size for the first Industry Box
  //   const minSize = 180;
  //   let curSize = 300;
  //   while ((expenseTextRef.current.clientWidth) < (expenseTextRef.current.scrollWidth) && curSize >= minSize) {
  //     // expenseTextRef.current.style.fontSize = `${curSize -= 10}%`;
  //   }

  //   // expenseTextRef.current.style.fontSize = `${curSize }%`;
  //   // thanTextRef.current.style.fontSize = `${curSize }%`;
  // })


  return (
    <div className="datavis-minidash" lang="en">
      <div className="datavis-minidash__row" ref={rowRef} style={{ maxWidth: "864px" }}>
        <div lang="en" ref={boxInd1} className="datavis-minidash__first-industry" style={{
          color: '#f5894e',
        }}>
          {props.isMobile ?
            props.ind1.replace(/\d{1,2}\.\s/, "").slice(0, 10).includes(" ") ?
              props.ind1.replace(/\d{1,2}\.\s/, "").slice(0) + "­"
              :
              props.ind1.replace(/\d{1,2}\.\s/, "").slice(0, 4) + "­"
              + props.ind1.replace(/\d{1,2}\.\s/, "").slice(4, 11) + "­"
              + props.ind1.replace(/\d{1,2}\.\s/, "").slice(11)
            :
            props.ind1.replace(/\d{1,2}\.\s/, "")
          }
        </div>
        <div ref={expenseTextRef} className="datavis-minidash__expenses-text">Expenses</div>
        <div ref={percentageBoxRef} className="datavis-minidash__percentage-figure">{diffPercentage}%</div>
        <div className="datavis-minidash__more-or-less-box">
          <div ref={moreBoxRef} className={`datavis-minidash__percentage-figure`}>{isMore === true ? 'More' : 'Less'}</div>
          <div ref={lessBoxRef} className={`datavis-minidash__more-or-less-box--less ${isMore === false ? 'active' : ''}`} style={{ display: "none" }}>Less</div>
        </div>
        <div ref={thanTextRef} className="datavis-minidash__than-text">Than</div>
        <div lang="en" ref={boxInd2} className="datavis-minidash__second-industry" style={{ color: '#f5894e', }}>
          {props.isMobile ?
            props.ind2.replace(/\d{1,2}\.\s/, "").slice(0, 10).includes(" ") ?
              props.ind2.replace(/\d{1,2}\.\s/, "").slice(0) + "­"
              :
              props.ind2.replace(/\d{1,2}\.\s/, "").slice(0, 4) + "­"
              + props.ind2.replace(/\d{1,2}\.\s/, "").slice(4, 11) + "­"
              + props.ind2.replace(/\d{1,2}\.\s/, "").slice(11)
            :
            props.ind2.replace(/\d{1,2}\.\s/, "")
          }
        </div>
      </div>
    </div>
  )
}

export default Minidash;